(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/multi-image-style-element.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/multi-image-style-element.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const toArrayOrNull = svs.content.image_v2.helpers.toArrayOrNull;

const setStyleElement = (contentId, images) => {
  const text = {
    styleTagId: 'image-v2',
    prefix: 'Styles for'
  };
  const head = document.querySelector('head');

  const getMediaQueriesString = (image, selector) => {
    const _ref = image || {},
      aspectRatio = _ref.aspectRatio,
      dominantColor = _ref.dominantColor,
      media = _ref.media;
    const declarations = [aspectRatio && "padding-bottom: ".concat(aspectRatio.height / aspectRatio.width * 100, "%;"), dominantColor && "background-color: ".concat(dominantColor, ";")];
    const declarationsString = declarations.filter(item => Boolean(item)).join('\n\t\t');
    return "@media only screen and ".concat(media, " {") + "\n\t.".concat(selector, " {") + "\n\t\t".concat(declarationsString, "\n\t") + "}\n}";
  };

  const hasMediaQueries = images => (images === null || images === void 0 ? void 0 : images.some(item => item && 'media' in item && 'aspectRatio' in item)) || false;

  const arrayToCssString = input => {
    const output = input === null || input === void 0 ? void 0 : input.map(_ref2 => {
      let id = _ref2.id,
        content = _ref2.content;
      const cssComment = "/* ".concat(text.prefix, " ").concat(id, " */\n\n");
      const style = "".concat(content, "\n\n");
      return "".concat(cssComment).concat(style).trim();
    });
    return (output === null || output === void 0 ? void 0 : output.join('\n\n')) || '';
  };

  const cssStringToArray = input => {
    const regex = new RegExp("\\/\\*\\s".concat(text.prefix, "(.*?)\\s\\*\\/([\\s\\S]*?)(?=\\/\\*\\s").concat(text.prefix, "|$)"), 'g');
    const matches = input.match(regex);
    const styles = matches.map(match => {
      regex.lastIndex = 0;
      const match2 = regex.exec(match) || [];
      const _match = _slicedToArray(match2, 3),
        id = _match[1],
        content = _match[2];
      return {
        id: id === null || id === void 0 ? void 0 : id.trim(),
        content: content === null || content === void 0 ? void 0 : content.trim()
      };
    }) || [];
    return styles;
  };

  const getStyleElement = id => {
    const existingElement = head.querySelector("#".concat(id));
    const hasExistingElement = Boolean(existingElement);
    const styleElement = hasExistingElement ? existingElement : document.createElement('style');
    return [styleElement, hasExistingElement];
  };
  const init = () => {
    const imagesArray = toArrayOrNull(images);
    if (!hasMediaQueries(imagesArray)) {
      return;
    }
    const cssDeclarationString = imagesArray.map(image => getMediaQueriesString(image, contentId)).join('\n');
    const _getStyleElement = getStyleElement(text.styleTagId),
      _getStyleElement2 = _slicedToArray(_getStyleElement, 2),
      styleElement = _getStyleElement2[0],
      hasExistingStyleElement = _getStyleElement2[1];
    if (hasExistingStyleElement) {
      const cssArray = cssStringToArray(styleElement.textContent);
      const thisIdIndex = cssArray.findIndex(item => item.id === contentId);
      const newValue = {
        id: contentId,
        content: cssDeclarationString
      };
      if (thisIdIndex !== -1) {
        cssArray[thisIdIndex] = newValue;
      } else {
        cssArray.push(newValue);
      }
      const cssString = arrayToCssString(cssArray);
      styleElement.textContent = cssString;
      return;
    }

    styleElement.id = text.styleTagId;
    const cssArray = [{
      id: contentId,
      content: cssDeclarationString
    }];
    styleElement.textContent = arrayToCssString(cssArray);
    head.appendChild(styleElement);
  };
  init();
};


const setupForImageElement = element => {
  var _element$dataset;
  const id = element === null || element === void 0 || (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.multiImageId;
  if (id) {
    const dataString = element.dataset.multiImageDataString;
    const data = JSON.parse(dataString);
    setStyleElement(id, data);
    delete element.dataset.multiImageDataString;
    delete element.dataset.multiImageId;
  }
};
svs.content.image_v2.helpers.multiImageStyleElement = {
  setupForImageElement,
  setStyleElement
};

 })(window);